export default __webpack_public_path__ + "static/media/item3.91361ce3.png";